import * as React from "react";

const CloseIcon = (props) => (
	<svg
		width={25}
		height={24}
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m21.5 21-9-9m0 0-9-9m9 9 9-9m-9 9-9 9"
			stroke="#5E666B"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default CloseIcon;
